import {LoaderButton} from '../loader-button';
import {mediaQueries} from '../../modules/common/styles/media-queries-breakpoints';
import {styled} from 'styled-components';

const HiddenNavButton = styled(LoaderButton)`
    margin-bottom: 16px;
    padding: 12px 24px;
    width: 296px;

    font-size: ${(props): string =>
        `${props.theme.fontSizes.medium}${props.theme.unitsOfMeasure.px}`};

    ${mediaQueries.lessThan('small')`        
        margin-left:16px;
        margin-right:16px;
        width: 100%;
        width: -moz-available;
        width: -webkit-fill-available;
        max-width: unset;
    `}
`;

export {HiddenNavButton};
